// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"7547827b","977":"b97dc880"}[chunkId] + ".chunk.js";
};